
import React, { PureComponent } from 'react'
import { reduxForm } from 'redux-form'
import DocumentsListComponentPage from '../../../../containers/management/fleets/documents/DocumentsListComponentPage'

class DocumentsFleetModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      disableClient: true,
      organizedUnit: null,
      dossierSubTypeId: null,
      openPanelFleet: true,
      openPanelClient: true,
      changeCheckAll: false,
      dataId: null,
      actionId: null
    }
  }

  componentDidUpdate () {
  }

  getSnapshotBeforeUpdate (prevProps) {
    return null
  }

  render () {
    const {
      showModal
    } = this.props

    if (!showModal || !this.props.fleet) { return null } else {
      return (
        <div id="documentsFleetModal">
          <DocumentsListComponentPage
            dossiersMode = {this.props.dossiersMode}
            fleet = {this.props.fleet}
            dossiers = {this.props.dossiers}
            dossierFleetDetails = {this.props.dossierFleetDetails}
            purchaseFleetDetails = {this.props.purchaseFleetDetails}
            fieldsConfiguration={this.props.fieldsConfiguration}
            create={this.props.create}
            tabActiveKey={this.props.tabActiveKey}
            moveToModifyDocumentsSelection={this.props.moveToModifyDocumentsSelection}
            dossierTypeSelected={this.props.dossierTypeSelected}
            change={this.props.change}
            changeDossierTypeSelected={this.props.changeDossierTypeSelected}
            allSelected={this.props.allSelected}
            documentsAllSelected={this.props.documentsAllSelected}
          ></DocumentsListComponentPage>
        </div>
      )
    }
  }
}

export default reduxForm({
  form: 'documentsFleetModal'

})(DocumentsFleetModal)
